import React, { useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useClassnames } from '@wb-tech/ui-react';
import { useTranslation } from 'react-i18next';

import { PORTAL_LINK } from '#core/const';
import { ELanguage } from '#core/const/locales';

import { IconLogo } from '#component/icons/logo';
import { IconVerticalLine } from '#component/icons/vertical-line';
import { IconPromotion } from '#component/icons/promotion';
import { IconLogoChinese } from '#component/icons/logo-chinese';

import style from './index.module.pcss';

interface IProps {
    size?: 'm' | 'l'
}

enum ERoutes {
    CampaignsList = '/campaigns/list',
    Login = '/login'
}

const DISABLED_LINK_ROUTES_LIST = [ERoutes.CampaignsList, ERoutes.Login];

export const HeaderLogo = ({ size = 'm' }: IProps) => {
    const cn = useClassnames(style);
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const location = useLocation();

    const elLinkOrDiv = useMemo(() => {
        const elIcon = currentLanguage === ELanguage.ZH ? <IconLogoChinese /> : <IconPromotion size={size} />;

        if(DISABLED_LINK_ROUTES_LIST.some((route: string) => location.pathname.includes(route))) {
            return elIcon;
        }

        return (
            <NavLink
                to={ERoutes.CampaignsList}
                className={cn('header-logo__promo-link')}
            >
                {elIcon}
            </NavLink>
        );
    }, [currentLanguage, location.pathname, size, cn]);

    return (
        <div
            className={cn('header-logo', {
                'header-logo_large': size === 'l'
            })}
        >
            <NavLink
                to={PORTAL_LINK}
                title={t('components.header-logo.links.portal.title')}
                className={cn('header-logo__title-link')}
            >

                <IconLogo />
            </NavLink>
            <IconVerticalLine size={size} />
            {elLinkOrDiv}
        </div>
    );
};
